/**
 * AndVVenn - 韦恩图组件
 * 基于 Ant Design Charts Venn
 */
import React from 'react';
import { Venn } from '@ant-design/plots';
import { withBaseChart } from '../base/BaseChart';
import type { AndVVennProps } from '../base/types';

const DEFAULT_VENN_DATA = [
  { sets: ['A'], size: 12 },
  { sets: ['B'], size: 10 },
  { sets: ['C'], size: 8 },
  { sets: ['A', 'B'], size: 3 },
  { sets: ['A', 'C'], size: 2 },
  { sets: ['B', 'C'], size: 2 },
  { sets: ['A', 'B', 'C'], size: 1 },
];

const VennWithBase = withBaseChart<AndVVennProps>(Venn, {
  chartType: 'AndVVenn',
  defaultHeight: 300,
  defaultData: DEFAULT_VENN_DATA,
});

export const AndVVenn: React.FC<AndVVennProps> = (props) => {
  const {
    setsField = 'sets',
    sizeField = 'size',
    colorField,
    ...baseProps
  } = props;

  const chartProps: Record<string, unknown> = {
    ...baseProps,
    setsField,
    sizeField,
  };

  if (colorField) chartProps.colorField = colorField;

  return <VennWithBase {...chartProps} />;
};

export type { AndVVennProps };
export default AndVVenn;
